import { render, staticRenderFns } from "./chooseCar.vue?vue&type=template&id=6fb9bd3a&scoped=true"
import script from "./chooseCar.vue?vue&type=script&setup=true&lang=js"
export * from "./chooseCar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./chooseCar.vue?vue&type=style&index=0&id=6fb9bd3a&prod&lang=scss&scoped=true"
import style1 from "./chooseCar.vue?vue&type=style&index=1&id=6fb9bd3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb9bd3a",
  null
  
)

export default component.exports